import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SimulationNotification } from '../../../core/models/SimulationNotification';

/**
 * Presentation component for the notification items shown in the lateral notification panel.
 *
 * @export
 * @class NotificationItemComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  standalone: false
})
export class NotificationItemComponent implements OnInit {

  /**
   * Notification data to display.
   *
   * @type {SimulationNotification}
   * @memberof NotificationItemComponent
   */
  @Input() data: SimulationNotification = null;

  /**
   * This flag should be set if the item is displayed within a notification alert component.
   *
   * It prevents the date from being displayed in the top right corner.
   *
   * @type {boolean}
   * @memberof NotificationItemComponent
   */
  @Input() withinPopup: boolean = false;

  /**
   * report the "close" events to the parent component.
   *
   * @memberof NotificationItemComponent
   */
  @Output() close = new EventEmitter<SimulationNotification>();

  /**
   * Report the "view" events to the parent component.
   *
   * @memberof NotificationItemComponent
   */
  @Output() view = new EventEmitter<SimulationNotification>();

  /**
   * Creates an instance of NotificationItemComponent.
   *
   * @memberof NotificationItemComponent
   */
  constructor() { }

  /**
   * Initialize the component.
   *
   * @memberof NotificationItemComponent
   */
  ngOnInit() {
  }

  /**
   * Trigger a callback in the parent component when the user makes the item disapear.
   *
   * @memberof NotificationItemComponent
   */
  doClose() {
    this.close.emit(this.data);
  }
  /**
   * Trigger a callback in the parent component when the user selects the view button.
   *
   * @memberof NotificationItemComponent
   */
  doView() {
    this.view.emit();
  }
}
